<!-- <div class="table-component">
<app-table  [headers]="headers"  (filter)="onFilter($event)"  [pagination]="pagination" [appliedFilter]="defaultFilters"
 (pageNumberChange)="selectedPage($event)" (recordsPerPageChange)="onRecordsPerPage($event)" ></app-table>
</div> -->
<div class="m-portlet__body">
    <!-- <div class="row" style="margin-top: 19px;  margin-left:16px">

					<div class="col-md-2">
						<label>
							<b>State</b>
						</label>
						<select class="form-control selectcolor" id="m_select2_1"  name="param" [(ngModel)]="modelObj.state" (change)="onChangeState()">
							<option value="" disabled selected>All</option>
							<option *ngFor="let state of states"  [ngValue] = state>
								{{state.name}}
							</option>
						</select>
					</div>
					<div class="col-md-2">
						<label>
							<b>District</b>
						</label>
						<select class="form-control selectcolor" id="m_select2_1"  name="param" [(ngModel)]="modelObj.district" >
							<option value="" disabled selected>All</option>
							<option *ngFor="let district of districts" [ngValue] = "district"> {{district.name}}</option>
						</select>
					</div>
					<div class="col-md-3">
						<div class= "m-input-icon m-input-icon--left row">
					<label class="search-text"><b>Enter Keywords to Search Particular Name:</b></label>
					<input  class="form-control m-input m-input--solid ng-pristine ng-valid ng-touched" [(ngModel)]="modelObj.userId" placeholder="Search by Candidate ID" type="text" ng-reflect-name="batchId">
					<span  class="m-input-icon__icon m-input-icon__icon--left" style="top: 12px;">
							<span ><i  class="la la-search"></i></span>
					</span>
					</div>
					</div>
					<div class="col-md-4">
						<label>
							<br> </label>
						<div>
							<button class="btn btn-primary" (click)="applyFilters()">
									Search
							</button>&nbsp;&nbsp;&nbsp;
							<button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
									Reset
							</button>
						</div>
					</div>
					<br>
					<br>
				</div>
				<br>
				<br> -->
    <!--begin: Search Form -->
    <div>
        <div class="row display-row">
            <div class="col-lg-2 col-xl-2 align-box">
                <label><b>State</b></label>
                <select class="form-control notranslate selectcolor" id="m_select2_1" name="param" [(ngModel)]="modelObj.state" (change)="onChangeState()">
							<option value="" disabled selected>All</option>
							<option *ngFor="let state of states" [ngValue]=state>
								{{state.name}}
							</option>
						</select>
            </div>
            <div class="col-lg-2 col-xl-2 align-box">
                <label><b>District</b></label>
                <select class="form-control notranslate selectcolor" id="m_select2_1" name="param" [(ngModel)]="modelObj.district">
						<option value="" disabled selected>All</option>
						<option *ngFor="let district of districts" [ngValue] = "district"> {{district.name}}</option>
						</select>
            </div>
            <div class="col-xl-3 col-sm-3 display-col1">
                <div class="m-input-icon m-input-icon--left row">
                    <label class="search-text">Enter Candidate ID to Search Particular Candidate</label>
                    <input class="form-control notranslate m-input m-input--solid ng-pristine ng-valid ng-touched" [(ngModel)]="modelObj.userId" placeholder="Search" type="text" ng-reflect-name="batchId">
                    <span class="m-input-icon__icon m-input-icon__icon--left" style="top: 12px;">
						<span><i class="la la-search"></i></span>
                    </span>
                </div>
            </div>
            <div class="col-lg-4 display-col2">
                <label for=""></label>
                <button class="btn btn-primary" (click)="applyFilters()">
					Search
				</button>&nbsp;&nbsp;&nbsp;
                <button class="btn btn-secondary m-btn reset-btn" (click)="reset()">
					Reset
				</button>
            </div>
        </div>

        <div class="form-group m-form__group row">
            <table class="table table-striped m-table">
                <thead class="table-head-style">
                    <tr>
                        <th>Sr. No.</th>
                        <th>Name of the Person</th>
                        <th>Email Address</th>
                        <th>Candidate ID</th>
                        <th>Assigned Job Vacancy</th>
                        <th>Employer</th>
                        <th *ngIf="this.user.role !== 'RozgarMela Admin'" style="text-align: center">Action</th>
                        <th>View Details</th>
                    </tr>
                </thead>
                <tbody class="notranslate">
                    <!-- <tr>
						<td style="text-align: center;color:#ef7e22;cursor: pointer;" (click)="viewMelaDetails()">View Details</td>
					</tr> -->
                    <!-- *ngFor ="let user of boData | search:searchBasedOnFields:searchText let i = index" -->
                    <tr *ngFor="let candidate of placedCandidateData, let i = index;">
                        <td>{{i+1}}</td>
                        <td>{{candidate.candidateName?candidate.candidateName: 'N/A'}}</td>
                        <td>{{candidate.candidateEmail?candidate.candidateEmail: 'N/A'}}</td>
                        <td>{{candidate.candidateId?candidate.candidateId: 'N/A'}}</td>
                        <td>{{candidate.jobVacancyDesc?.name?candidate.jobVacancyDesc.name: 'N/A'}}</td>
                        <td>{{candidate.placedBy?.userName?candidate.placedBy.userName:'N/A'}}</td>
                        <td *ngIf="this.user.role !== 'RozgarMela Admin'" style="text-align: center;color:#ef7e22; cursor: pointer;">Update Placement Details</td>
                        <td>
                            <div class="dropdown dropup">
                                <a href="#" class="btn m-btn m-btn--hover-accent m-btn--icon m-btn--icon-only m-btn--pill" data-toggle="dropdown" aria-expanded="false">
                                    <i class="la la-ellipsis-h"></i>
                                </a>
                                <div class="dropdown-menu dropdown-menu-right" x-placement="top-end" style="position: absolute; transform: translate3d(-132px, -143px, 0px); top: 0px; left: 0px; will-change: transform;">
                                    <a class="dropdown-item" (click)="viewCandidateDetails(candidate.candidateId)">View Details</a>
                                </div>
                            </div>
                        </td>

                    </tr>
                    <!-- <tr *ngFor="let empData of alignedEmployeeArray | search: searchBasedOnFields: searchText let i = index;">
						<td style="width: 10%;">{{i+1}}</td>
						<td>{{empData.orgName?empData.orgName:'Not Available'}}</td>
						<td>{{empData.hrSpoc?.name?empData.hrSpoc.name:'Not Available'}}</td>
						<td>{{empData.address?.state?empData.address.state: 'Not Available'}} {{empData.address.districtDetails?.district?empData.address.districtDetails.district: 'Not Available'}}</td>
						<td>{{empData.hrSpoc?.mobile?.phone?empData.hrSpoc.mobile.phone:'Not Available'}}</td>
						<td>{{empData.createdBy?.userName?empData.createdBy.userName:'Not Available'}}</td>
						<td>0</td>
						<td style="text-align: center;color:#ef7e22; cursor: pointer;" (click)="viewMelaDetails(empData)">View Details</td>
					  </tr> -->
                    <!-- <tr>
						  <td style="width: 10%;">{{1}}</td>
							<td>{{user.user.userName}}</td>
							<td>{{user?.user?.email?user.user.email:'N/A'}}</td>
							<td>{{user?.user?.phone?.mobile?user.user.phone.mobile:'N/A'}}</td>
							<td>{{user?.address?.state?user.address.state:'N/A'}}</td>
              <td>{{user?.address?.districtDetails?.district?user.address.districtDetails.district:'N/A'}}</td>
              <td>{{user?.address?.districtDetails?.district?user.address.districtDetails.district:'N/A'}}</td>
							<td style="text-align: center;color:#ef7e22" routerLink="view-employer-details">View Details</td>
						</tr> -->
                    <!-- *ngIf="!boData"  -->
                    <tr *ngIf="placedCandidateData.message" style="color:red;font-size:17px">
                        <td colspan="8">
                            {{placedCandidateData.message}}
                        </td>
                    </tr>
                </tbody>
            </table>

        </div>
    </div>
    <div *ngIf="(length)">
        <app-pagination [count]="length" (pageNumber)="onPageChange($event)" (recordsPerPage)="onRequiredPerPageChage($event)"></app-pagination>
    </div>
</div>